import { useQuery, useMutation } from "@tanstack/react-query";

import { API, graphqlOperation } from "aws-amplify";

import { GraphQLQuery } from "@aws-amplify/api";

import { recommendToUser } from "@/graphql/mutations";

import { getListNotifRecommendation } from "@/graphql/queries";

import { IUseRecommendToUser } from "@/types";

const fetchListNotifRecommendation = async (
  contextType: "CIRCLE" | "EVENT" | "CONNECTION",
) => {
  const response: any = await API.graphql(
    graphqlOperation(getListNotifRecommendation, { contextType }),
  );
  const records: any[] = response?.data?.getListNotifRecommendation ?? [];

  return records;
};

const useGetListNotifRecommendation = (
  contextType: "CIRCLE" | "EVENT" | "CONNECTION",
) => {
  return useQuery({
    queryKey: ["KEY_GET_NOTIF_RECOMMENDATION", contextType],
    queryFn: () => fetchListNotifRecommendation(contextType),
  });
};

// Mutation for send data recommendation to users

const sendRecommendToUser = async (payload: IUseRecommendToUser): Promise<any> => {
  return await API.graphql<GraphQLQuery<any>>({
    query: recommendToUser,
    variables: payload,
  });
};

const useRecommendToUser = () => {
  return useMutation(sendRecommendToUser);
};

// Export all hooks
export { useRecommendToUser, sendRecommendToUser, useGetListNotifRecommendation };
